exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Fix for checkboxes label */\n.custom-control-label[data-v-7405e13c] {\n  padding-top: 2px;\n}\n.tree-menu-item[data-v-7405e13c] {\n  padding: 0.2em 1em;\n}\n.tree-menu-item img.cbx[data-v-7405e13c] {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-7405e13c","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/CheckableTreeViewItem.vue
// module id = MPOw
// module chunks = 97